export default __webpack_public_path__ + "static/media/Ballroll_00162.d32dd83a.png";